// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BarcodeScannerController from "./barcode_scanner_controller"
application.register("barcode-scanner", BarcodeScannerController)

import LiveSearchController from "./live_search_controller"
application.register("live-search", LiveSearchController)

import ProductSearchController from "./product_search_controller"
application.register("product-search", ProductSearchController)

import ProductSelectController from "./product_select_controller"
application.register("product-select", ProductSelectController)

import RecipeIngredientsController from "./recipe_ingredients_controller"
application.register("recipe-ingredients", RecipeIngredientsController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ModalCloseController from "./modal_close_controller"
application.register("modal-close", ModalCloseController)

import ShoppingSearchController from "./shopping_search_controller"
application.register("shopping-search", ShoppingSearchController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)
